import { CountUp } from 'countup.js';
import { gsap } from '../vendor/gsap';
import { ScrollTrigger } from '../vendor/gsap/ScrollTrigger';
import transparentBeforeAnimation from '../lib/transparent-before-animation';

gsap.registerPlugin(ScrollTrigger);

const moduleSelector = '.js-numbers';
const moduleCallBack = (moduleElement, query, queryAll) => {
    const keyNumbers = queryAll('.key-number-item');
    const keyNumbersContent = queryAll('.key-number-content');
    const timeline = gsap.timeline({
        scrollTrigger: {
            trigger: moduleElement,
            start: 'top 70%',
        },
    });

    keyNumbers.forEach((item) => {
        const itemContent = item.querySelector('.key-number-content');
        transparentBeforeAnimation(itemContent, timeline);
    });

    timeline.from(keyNumbersContent, {
        opacity: 0,
        duration: 0.3,
        stagger: 0.1,
    }, 'start+=0');

    timeline.call(() => {
        keyNumbers.forEach((item) => {
            const numberElement = item.querySelector('.key-number');
            if (numberElement.classList.contains('animated')) {
                const counter = item.querySelector('.counter');
                const end = counter.getAttribute('data-count');
                const start = counter.textContent;
                let decimal = 0;
                if (end.indexOf('.') > 0) {
                    decimal = end.toString().split('.')[1].length;
                }
                const numAnim = new CountUp(counter, parseFloat(end), {
                    startVal: parseFloat(start),
                    useEasing: true,
                    useGrouping: true,
                    separator: '',
                    decimalPlaces: decimal,
                });
                numAnim.start();
            }
        });
    }, null, 'start+=0.1');
};

export { moduleSelector, moduleCallBack };
